import { GlobalInsurance, InsuranceItem } from '../../../models/insurance-item.model';
import { FormGroup } from '@angular/forms';

export class TransporterMapper {
  static getGlobalInsuranceFromInsuranceItem(insuranceItem: InsuranceItem): GlobalInsurance {
    const globalInsurance = new GlobalInsurance();
    globalInsurance.insuranceRate = insuranceItem.insuranceRate!;
    globalInsurance.basePricing = insuranceItem.basePricing!;
    globalInsurance.itemNature = insuranceItem.itemsNature!;
    globalInsurance.maxValue = insuranceItem.maxValue!;
    globalInsurance.pricingRate = insuranceItem.pricingRate!;
    return globalInsurance;
  }

  static getGlobalInsuranceFromFormGroup(formGroup: FormGroup): GlobalInsurance {
    const globalInsurance = new GlobalInsurance();

    globalInsurance.insuranceChoice = formGroup.get('insurance')!.value;
    globalInsurance.insuranceRate = formGroup.get('insuranceRate')!.value;
    globalInsurance.maxValue = formGroup.get('maxValue')!.value;
    globalInsurance.basePricing = formGroup.get('basePricing')!.value;
    globalInsurance.pricingRate = formGroup.get('pricingRate')!.value;
    globalInsurance.notifyOneByOneActivated = formGroup.get('notifyOneByOneActivated')!.value;
    globalInsurance.monthlyReportActivated = formGroup.get('monthlyReportActivated')!.value;
    globalInsurance.warningAmount = formGroup.get('warningAmount')!.value;

    return globalInsurance;
  }
}
